import { SUBDOMAINS } from '@constants/config';

export const verifySubdomain = {
	isDrive: (subdomain) => subdomain === SUBDOMAINS.drive,
	isMy: (subdomain) => subdomain === SUBDOMAINS.my
};
